<template>
  <div>
    
  
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>
  </el-row>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

    <el-row class="ml-20 mr-20" >
      <el-col :xs="12" :sm="12" :lg="12">
        <el-button icon="el-icon-search" circle type="warning" @click="drawer = true"></el-button>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12" >
        <el-button type="primary" @click.prevent="createTodo" style="float: right;">新增 <i class="el-icon-circle-plus-outline"></i>
      </el-button>
      </el-col>
    </el-row>
  
  <el-row>
    

    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-table :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
          <el-table-column prop="title" label="標題" width="160">
              <template slot-scope="scope">
                <router-link :to="`${scope.row.todoUrl}${scope.row.id}`">{{scope.row.title }}
                </router-link>
                <p>{{scope.row.reqPayNo}}</p>
              </template>
          </el-table-column>

          <el-table-column label="請款金額"  width="90">
            <template slot-scope="scope">
              NTD{{ scope.row.totalPrice }}
            </template>
          </el-table-column>
          
          <el-table-column label="狀態" width="90">
            <template slot-scope="scope">
              <el-tag :type="caseType(scope.row.status)">{{ scope.row.status | fmtSignResult}}</el-tag>
            </template>
          </el-table-column>

         <!--  <el-table-column label="" type="expand" width="30">
              <template slot-scope="scope">
                
                <el-form label-position="left" inline class="demo-table-expand" v-if="scope.row.status === 'close'">
                  <ol class="mt-10 ml-10">
                    <li v-for="f in scope.row.relatedJobs" :key="f.id" class="mt-10">
                      {{f.updatedAt | fmtDateTime}}, {{f.signerObj.username}}, {{f.notes}}
                    </li>
                  </ol>
                </el-form>
              </template>
            </el-table-column> -->

          <el-table-column label="操作" width="110">
              <template slot-scope="scope">
                <el-popconfirm
                    class="ml-10 popconfirm-bg"
                    title="確定刪除此筆資料嗎?"
                    confirm-button-text="確定"
                    cancel-button-text="取消刪除"
                    @confirm="handleDelete(scope.row.id)"
                >
                  <el-button v-if="scope.row.status === 'draft'" type="danger" icon="el-icon-delete" circle slot="reference"></el-button>
                </el-popconfirm>
                <!-- <el-popconfirm
                    class="ml-10 popconfirm-bg"
                    title="確定作廢此筆資料嗎?"
                    confirm-button-text="確定"
                    cancel-button-text="取消"
                    @confirm="handleInvalid(scope.row.id)"
                >
                  <el-button v-if="scope.row.status === 'close'" type="warning" icon="el-icon-document-delete" circle slot="reference"></el-button>
                </el-popconfirm> -->
              </template>
            </el-table-column>

        </el-table>

        <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
          <el-pagination
              background
              layout="prev, pager, next"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>

      </el-main>
    </el-col>

    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    <el-dialog title="請款單資訊"
               :visible.sync="dialogFormVisible"
               :width="dw"
               @close="closeDialog">
      <el-form :model="form"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="付款方式" prop="payType">
          <el-select v-model="form.payType" placeholder="選擇請款類型" width="100%">
            <el-option
                v-for="item in payTypeOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="請款金額" prop="price">
          <el-input v-model="form.price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="請款說明" prop="description">
          <el-input type="textarea" :rows="2" placeholder="請輸入說明" v-model="form.description"
                    autocomplete="off"></el-input>
        </el-form-item>


        <el-row v-for="(btn, i) in btnCount" :key="i">
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="檔案備註">
              <el-input placeholder="檔案備註" v-model="form.fileNotes[i]" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="附件">
              <el-upload
                  :multiple="false"
                  class="upload-demo"
                  action="/api/file/upload"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload"
                  :on-remove="handleFileRemove"
                  :file-list="fileList">
                <el-button size="small" type="primary">上傳文件</el-button>
                <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-button size="small" type="primary" @click="newUploadField()">新增上傳</el-button>
          </el-col>
        </el-row>
        <!-- 

        <el-form-item label="請款附件" prop="attachment">
          <el-upload
              :multiple="false"
              class="upload-demo"
              action="/api/file/upload"
              :file-list="fileList"
              :on-success="handleUploadSuccess"
              :before-upload="beforeUpload">
            <el-button size="small" type="primary">上傳文件</el-button>
            <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
          </el-upload>
        </el-form-item> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData('dataForm')">確 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="請款單資訊"
               :visible.sync="signFormVisible"
               width="40%">


      <el-form :model="signForm"
               ref="signForm">
        <el-form-item label="請款單資訊已確認無誤，點選確認後會將表單送主管簽核。" prop="notes">
          
          <el-input type="hidden" placeholder="請輸入送簽備註" v-model="signForm.notes" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="signFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSignForm('signForm')">確　認</el-button>
      </div>
    </el-dialog>

    <el-drawer
        size="70%"
        title="搜尋"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">

        <el-select :xs="24" v-model="queryField" placeholder="選擇搜尋條件" style="padding: 0 0 0 10px">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

        <el-input v-model="keyword" style="width: 200px" placeholder="輸入關鍵字" class="mt-10 ml-10"
                  suffix-icon="el-icon-search"></el-input>

        <el-button type="primary" @click.prevent="search" class="mt-10 ml-10">查詢</el-button>
        <el-button type="normal" @click.prevent="clearQuery" class="mt-10 ml-10">清除條件</el-button>
        

       
      </el-drawer>
      

  </el-row>
</div>

</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import request from "@/api/request";

export default {
  name: "ReqPayMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {
      editMode: false,
      drawer: false,
      direction: 'ltr',

      dw: '60%',
      gridData: [],
      tableData: [],
      options: [{
        value: 'totalPrice',
        label: '請款金額大於'
      }],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 15,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      payTypeOption: [],
      btnCount: 0,
      form: {
        submitBy: this.$store.state.login.userInfo.id,
        payType: '',
        price: 0,
        description: '',
        attachmentUuid: '',
        attachmentName: '',
        fileList: [],
        fileNotes: [],

        form:'',
        startDate:'',
        status: 'draft',
        todoType: 'req_pay'
      },
      signForm: {
        payId: 0,
        submitBy: this.$store.state.login.userInfo.id,
        notes: ''
      },
      signFormVisible: false,

      roles: [],
      rules: {
        payType: [{required: true, validator: checkName, trigger: 'change'}],
        price: [{required: true, validator: checkName, trigger: 'change'}],
        description: [{required: true, validator: checkName, trigger: 'change'}]
      }
    }
  },
  methods: {
    handleClose(){
      this.drawer = false
    },
    createTodo(){
      this.form.title = "請款單"
      this.form.startDate = new Date()
      this.request.post("/todo", this.form).then(res => {
        if (res.code === '200') {
          this.$router.push(res.data.todoUrl + res.data.id)
        }
      })
    },
    search() {
      this.drawer = false
      this.loadData()
    },
    loadType() {
      let req = '/dic/type?queryField=apply_pay'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.payTypeOption = res.data
        }
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadData()
    },
    clearQuery() {
      this.drawer = false
      this.keyword = ''
      this.queryField = ''
      this.loadData()
    },
    newUploadField() {
      this.btnCount++
    },

    /** data crud **/
   loadData() {
     

      let {pageNum, pageSize, queryField, keyword} = this

      let url = "/req-pay/my?pageNum=" + pageNum + "&pageSize=" + pageSize + "&queryField=" + queryField + "&keyword=" + keyword
      this.request.get(url).then(res => {
          if (res.code === '200') {
            this.drawer = false

            this.tableData = res.data.records
            this.total = res.data.total

            
          } else {
            this.showResult('error', "資料取得失敗")
          }
        })


    },
     saveData(formName) {
      this.$refs[formName].validate(async valid => {
        
        if (valid) {
            this.request.post("/req-pay", this.form).then(res => {
              if (res.code === '200') {
                this.dialogFormVisible = false

                this.loadData()

                this.showResult('success', '資料更新成功')
              } else {
                this.showResult('error', "資料更新失敗")
              }
            })
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.id = null
      this.form.fileList = []
      this.form.fileNotes = []
      this.btnCount = 0
    },
    handleEdit(rowData) {
      this.dialogFormVisible = true
      this.form = rowData
    },
    handleDelete(id) {

      this.request.delete("/todo/" + id).then(res => {
          if (res.code === '200') {
            this.loadData()
            this.showResult('success', '資料刪除成功.')
          } else {
            this.showResult('error', '資料刪除失敗.')
          }
      })
    },
    handleInvalid(id) {
      this.request.post("/todo/invalid/" + id).then(res => {
          if (res.code === '200') {
            this.loadData()
            this.showResult('success', '資料作廢成功.')
          } else {
            this.showResult('error', '資料作廢失敗.')
          }
      })
    },
    handleSignoff(row) {
      this.signForm.payId = row.id
      this.signForm.notes = ''
      this.signFormVisible = true
    },
    closeDialog() {
      this.$refs['dataForm'].resetFields()
      this.loadData()
    },
    exportData() {
      window.open(process.env.VUE_APP_API_SERVER + '/product/export', "new")
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },

    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },

    async submitSignForm(rowData) {


      console.log(this.signForm)
      this.signFormVisible = false
      try {
        await this.$store.dispatch('reqPay/submitSignForm', this.signForm)
        this.showResult('success', '簽核送出成功')

        await this.loadData()

      } catch (e) {
        this.showResult('error', e.message)
      }
    },

    caseType(status) {
      if (status === 'draft') return ''
      if (status === 'review') return 'warning'
      if (status === 'reject') return 'danger'
      if (status === 'close') return 'success'
      if (status === 'invalid') return 'danger'
    },

    async signoffHistory(row) {
      console.log('row:', row.id)
      try {
        let result = await this.$store.dispatch('reqPay/getSignOffHistory', row.id)
        this.gridData = result.data.records

      } catch (e) {
        this.showResult('error', e.message)
      }
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = '60%'
      }
    }

  },
  mounted() {
    this.loadData()
    

    this.setDialogWidth();
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}
.myform >>> .el-form-item__label {
  padding: 0;
}
.mymain {
  padding: 20px 4px;
}
.mytable {
  padding: 10px;
}
.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 8px;
}

.taskMain >>> .el-card__body {
  padding: 0;
}
.el-table {
  padding: 0;
}


</style>
